import { render, staticRenderFns } from "./ProjectViewPMList.vue?vue&type=template&id=6859e271&scoped=true&"
import script from "./ProjectViewPMList.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewPMList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewPMList.vue?vue&type=style&index=0&id=6859e271&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859e271",
  null
  
)

export default component.exports